"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActorName = exports.concatUsersInfo = exports.concatUserInfo = exports.concatCreatorsInfo = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _locales = require("./locales");
/**
 * Return as System User if no valid info with give user info.
 *
 * @param name - The username
 * @param oxygenId - The user autodeskId
 * @returns The user detail name
 */
var getActorName = exports.getActorName = function getActorName(name, oxygenId) {
  if (oxygenId) return name;
  return name || (0, _locales.translate)('users.accSystem');
};

/**
 * Get user map by oxygenId
 */
var getUsersMap = (0, _memoizeOne["default"])(function (projectUsers) {
  var oxygenMap = new Map();
  projectUsers.forEach(function (user) {
    user.oxygenId && oxygenMap.set(user.oxygenId, user);
  });
  return oxygenMap;
});

/**
 * Map user company, name and profile image on demand
 *
 * @param item - The entity item
 * @param userMap - Project user map
 * @returns Remapped entity item with detail user info
 */
var setUpdateUserInfo = function setUpdateUserInfo(item, userMap) {
  var updated = (0, _extends2["default"])({}, item);

  // Set version user info
  if (updated.version) {
    // Need a spread to version to avoid read-only error
    var version = (0, _extends2["default"])({}, updated.version);
    if (!version.createUserId) {
      version.createUserName = getActorName(version.createUserName);
    } else {
      var user = userMap.get(version.createUserId);
      version.createUserName = version.createUserName || (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.email);
      version.createUserCompany = (user === null || user === void 0 ? void 0 : user.company) || {};
      version.createUserProfileImg50 = user === null || user === void 0 ? void 0 : user.profileImg50;
    }
    if (!version.lastModifiedUserId) {
      version.lastModifiedUserName = getActorName(version.lastModifiedUserName);
    } else {
      var _user = userMap.get(version.lastModifiedUserId);
      version.lastModifiedUserName = version.lastModifiedUserName || (_user === null || _user === void 0 ? void 0 : _user.name) || (_user === null || _user === void 0 ? void 0 : _user.email);
      version.lastModifiedUserCompany = (_user === null || _user === void 0 ? void 0 : _user.company) || {};
    }
    updated.version = version;
  }

  // Setup last modified user info
  if (!updated.lastModifiedUserId) {
    updated.lastModifiedUserName = getActorName(item.lastModifiedUserName);
  } else {
    var _user2 = userMap.get(updated.lastModifiedUserId);
    updated.profileImg50 = _user2 === null || _user2 === void 0 ? void 0 : _user2.profileImg50;
    updated.lastModifiedUserName = updated.lastModifiedUserName || (_user2 === null || _user2 === void 0 ? void 0 : _user2.name) || (_user2 === null || _user2 === void 0 ? void 0 : _user2.email);
    updated.lastModifiedUserCompany = (_user2 === null || _user2 === void 0 ? void 0 : _user2.company) || {};
  }
  return updated;
};

/**
 * Setup creator and updater user name and company info from project users if needed
 *
 * @param item - The entity item
 * @param users - The project users
 * @returns Mapped item with detail user name, profile image and company info
 */
var concatUserInfo = exports.concatUserInfo = function concatUserInfo(item, users) {
  var userMap = getUsersMap(users || []);
  return setUpdateUserInfo(item, userMap);
};

/**
 * Setup creator and updater username and company info from project users if needed
 *
 * @param items - The entity list
 * @param users - The project users
 * @returns Mapped items with detail username, profile image and company info
 */
var concatUsersInfo = exports.concatUsersInfo = function concatUsersInfo(items, users) {
  var userMap = getUsersMap(users || []);
  return (items || []).map(function (item) {
    return setUpdateUserInfo(item, userMap);
  });
};

/**
 * Setup creator user name and company info for items. E.g. versionSets and collections in Sheets
 * @param items - The items contain createdBy info
 * @param users - The user items e.g. project users
 * @returns Mapped items with detail creator company, profile image and name.
 */
var concatCreatorsInfo = exports.concatCreatorsInfo = function concatCreatorsInfo(items, users) {
  var userMap = getUsersMap(users || []);
  return (items || []).map(function (item) {
    var user = userMap.get(item.createdBy);
    return (0, _extends2["default"])({}, item, {
      profileImg50: user === null || user === void 0 ? void 0 : user.profileImg50,
      createdByName: item.createdByName || (user === null || user === void 0 ? void 0 : user.name) || (user === null || user === void 0 ? void 0 : user.email),
      createdByCompany: (user === null || user === void 0 ? void 0 : user.company) || {}
    });
  });
};